import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { AdUnitForTable } from '../../types'
import { adUnitForTableFromDTO, sortToDTO } from './api/mapper'
import { GET_AD_UNITS_FOR_TABLE } from './api/query'
import { AdUnitForTableDTO, Data, Variables } from './api/types'
import { UseAdUnits, UseAdUnitsProps } from './types'

export const useAdUnits = ({ filters, first, last, sort }: UseAdUnitsProps): UseAdUnits => {
  const { workspaceId } = useWorkspaceParam()
  const [adUnits, setAdUnits] = useState<AdUnitForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        adUnits: { nodes: adUnits, totalCount: count },
      } = data

      if (adUnits) {
        setAdUnits(
          adUnits.map((node: AdUnitForTableDTO): AdUnitForTable => adUnitForTableFromDTO(node)),
        )
        setCount(count)
      }
    },
    options: {
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
    },
    query: GET_AD_UNITS_FOR_TABLE,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return {
    adUnits,
    count,
    loading,
    setAdUnits,
  }
}
